export const voices = [
  {
    id: 'v-01',
    name: '深夜刷榜的猫',
    tag: '娱乐圈内幕',
    text: '看完那篇对赌协议的拆解，我才明白为什么有些剧本改到最后完全变味。以前只觉得是编剧不行，现在看是结构问题。',
    likes: 1284,
    time: '2 小时前',
  },
  {
    id: 'v-02',
    name: '蹲在直播间',
    tag: '网红圈潜规则',
    text: '保底协议这段写得太准了。我们小机构就是被押着走量，做不到就返坑位费，账期还拖得特别久。',
    likes: 962,
    time: '4 小时前',
  },
  {
    id: 'v-03',
    name: '理性追星手册',
    tag: '饭圈操作',
    text: '不是想否定谁的努力，但集资流向确实该有个说得清的公示方式。透明了，大家反而更愿意参与。',
    likes: 811,
    time: '5 小时前',
  },
  {
    id: 'v-04',
    name: '甲方第七年',
    tag: '资本运作',
    text: '投放结算单那段太真实了，同一批账号换个壳再来一遍，报价还能翻倍，我们内部其实都知道。',
    likes: 704,
    time: '7 小时前',
  },
  {
    id: 'v-05',
    name: '匿名线索员',
    tag: '行业黑幕',
    text: '手里还有两份类似材料，已经按站内方式提交了。希望整理的时候把可核验的部分单独标出来，这样更有说服力。',
    likes: 655,
    time: '9 小时前',
  },
  {
    id: 'v-06',
    name: '只想看逻辑',
    tag: '幕后推手',
    text: '喜欢这种不急着下结论的写法。把时间线和报价摆出来，读者自己就能看出问题在哪，比喊口号有力多了。',
    likes: 528,
    time: '11 小时前',
  },
];

export const hotWords = ['对赌条款', '保底协议', '控评手册', '股权代持', '刷量报价', '宣发闭环', '集资流向', '舆情三段式'];